import { ReactNode } from "react";

interface SectionProps {
  title: string;
  children: ReactNode;
  id?: string;
  colorTheme?: number;
}

const themeColors = [
  {
    header: "bg-[#ff9800] dark:bg-[#e68900]",
    headerText: "text-white dark:text-white",
    border: "border-[#ff9800] dark:border-[#e68900]",
  },
  {
    header: "bg-[#00b0be] dark:bg-[#009aa6]",
    headerText: "text-white dark:text-white",
    border: "border-[#00b0be] dark:border-[#009aa6]",
  },
  {
    header: "bg-[#b7d435] dark:bg-[#9bb82d]",
    headerText: "text-white dark:text-white",
    border: "border-[#b7d435] dark:border-[#9bb82d]",
  },
  {
    header: "bg-[#ce0060] dark:bg-[#b00050]",
    headerText: "text-white dark:text-white",
    border: "border-[#ce0060] dark:border-[#b00050]",
  },
];

export function Section({ title, children, id, colorTheme }: SectionProps) {
  const theme = colorTheme !== undefined ? themeColors[colorTheme % themeColors.length] : null;
  
  if (theme) {
    return (
      <div id={id} className={`bg-white dark:bg-gray-800 rounded-lg border ${theme.border} shadow-sm`}>
        <div className={`${theme.header} px-6 py-4 rounded-t-lg`}>
          <h3 className={`text-lg font-subheader ${theme.headerText} mb-0`}>
            {title}
          </h3>
        </div>
        <div className="p-6 space-y-4">
          {children}
        </div>
      </div>
    );
  }

  return (
    <div id={id} className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6 shadow-sm">
      <h3 className="text-lg font-subheader text-gray-900 dark:text-gray-100 mb-4 border-b border-gray-100 dark:border-gray-700 pb-2">
        {title}
      </h3>
      <div className="space-y-4">
        {children}
      </div>
    </div>
  );
}
